<template>
  <div class="ui-content dashboard leader-sub">
      <div class="past-test-dropdown monitor-users-search cp3-monitor-users-search cp3-search-label"  :class="{'cp3-search-label-width': tab === 'Test Results'}">
      <v-text-field
          class="search-box"
          @keydown="onSearch()"
          outlined
          :label="tab === 'Test Results' ? 'Name/Email ID/Student ID/Roll No.' : 'Name/Student ID/Roll No.'"
          v-model="search"
          append-icon="mdi-magnify"
        />
      
    </div>
    <div class="page-user user MonitorUserstd">
      <v-tabs
        v-model="tab"
        background-color
        class="elevation-2 cust-tab"
        :centered="centered"
        :grow="grow"
        :vertical="vertical"
        :right="right"
        :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
        :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
        :icons-and-text="icons"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab :href="'#Test Results'">Test Results</v-tab>
        <v-tab :href="'#Health Analysis'">Health Analysis</v-tab>
        <v-tabs-items :touchless="true" v-model="tab">
          <v-tab-item :value="'Test Results'">
            <v-card class="mx-auto normal-card">
              <MonitorUsersstudent
                :updateRouteDetails="updateRouteDetails"
                :searchQuery="searchQuery"
                :selectedTab="tab"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Health Analysis'">
            <v-card class="mx-auto normal-card">
              <StudentwiseHealth
                :searchQuery="searchQuery"
                :selectedTab="tab"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import MonitorUsersstudent from "@/components/coordinator/users/MonitorUsers/MonitorUsersstudent.vue";
import StudentwiseHealth from "@/views/pages/health/StudentwiseHealth.vue";
export default {
  name: "MonitorUsers",
  components: {
    MonitorUsersstudent,
    StudentwiseHealth,
  },
  data() {
    return {
      tab: null,
      icons: false,
      centered: false,
      grow: false,
      vertical: false,
      prevIcon: false,
      nextIcon: false,
      right: false,
      searchQuery: "",
      search: "",
      tabs: 3,
    };
  },
  mounted() {
	  this.checkSessionData()
    this.defaultData();
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "centerIds":
          crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;
          break;
        case "batchIds":
          crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;
          break;
        case "classIds":
          crd.tabDetails[crd.selectedTab].classIds = details.data.classIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.tab = crd.selectedTab ? crd.selectedTab : "Test Results";
      }
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          "Test Results": {
            page: 1,
            showActivated: 1,
            centerIds: [],
            batchIds: [],
            classIds: [],
            orderBy: {
              field: "name",
              order: "ASC",
            },
          },
          "Health Analysis": {
            page: 1,
            showActivated: 1,
            centerIds: [],
            batchIds: [],
            orderBy: {
              field: "name",
              order: "ASC",
            },
          },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: this.tab,
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
    },
    onSearch() {
      let routeName = this.$route.name;

      if (this.typetimeout) {
        clearTimeout(this.typetimeout);
      }
      this.typetimeout = setTimeout(() => {
        this.searchQuery = this.search;
        let updatedDetails = { searchText: this.searchQuery };
        updatedDetails.routeName = routeName;
        this.setRouteDetails(updatedDetails);
      }, 1500);
    },
  },
  watch: {
    tab(val, oldVal) {
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val, searchText: "" });
        this.searchQuery = "";
        this.search = "";
      }
      this.addBreadCrumbChilde([
        {
          text: val,
          disabled: false,
        },
      ]);
    },
  },
};
</script>
